import { MessagingPlatform } from '../messagingPlatform.enum';
import { TriggerKey } from '../userCommunicationAgent';

export enum EmailAccountScope {
  ALL = 'ALL',
  SELECTED = 'SELECTED',
}

export enum GmailFilterType {
  ALL = 'all',
  BY_LABEL = 'by_label',
  BY_AUTHOR_EMAIL = 'by_author_email',
  BY_CATEGORY = 'by_category',
  BY_ARCHIVED = 'by_archived',
}

export enum CommunicationTimeInterval {
  LAST_HOURS = 'last_hours',
  TODAY = 'today',
  THIS_WEEK = 'this_week',
}

// Email trigger configs

export interface BaseEmailTriggerConfig {
  emailAccountScope: EmailAccountScope;
  selectedEmailAddresses?: string[]; // required if emailAccountScope is 'SELECTED'
  contactsOnly?: boolean;
  requireDirectTo?: boolean;
}

export interface AllEmailsTriggerConfig extends BaseEmailTriggerConfig {}

export interface PrimaryInboxTriggerConfig extends BaseEmailTriggerConfig {}

export interface LabelMatchTriggerConfig extends BaseEmailTriggerConfig {
  labelIds: string[];
}

export interface CategoryMatchTriggerConfig extends LabelMatchTriggerConfig {}

export interface EmailMatchTriggerConfig extends BaseEmailTriggerConfig {
  emails: string[];
}

export interface DomainMatchTriggerConfig extends BaseEmailTriggerConfig {
  domains: string[];
}

// Email step configs

export interface LabelStepConfig {
  labelIds: string[];
}

export interface ChangeCategoryStepConfig {
  category: string;
}

export interface RecipientsStepConfig {
  recipients: string[];
}

export interface DraftEmailStepConfig {
  recipient?: string;
  subject?: string;
  body?: string;
  senderEmailAddress?: string; // the mailbox the step sends as; wins over the trigger email's mailbox, which it falls back to when not connected
}

export interface DraftReplyStepConfig {
  body?: string;
}

export interface SendReplyStepConfig {
  body?: string;
}

export interface LoadCommunicationsStepConfig {
  platform?: MessagingPlatform;
  timeInterval?: string;
  hours?: string;
  filterType?: string;
  filterValue?: string;
  labelIds?: string[];
}

export interface SendEmailStepConfig {
  recipients: string[];
  subject: string;
  body: string;
  senderEmailAddress?: string; // the mailbox the step sends as; wins over the trigger email's mailbox, which it falls back to when not connected
}

export interface SendNotificationEmailStepConfig {
  recipients: string[];
  heading?: string;
  subject?: string;
  description?: string;
}

export const EMAIL_TRIGGER_KEYS = [
  TriggerKey.ALL_EMAILS,
  TriggerKey.PRIMARY_INBOX,
  TriggerKey.LABEL_MATCH,
  TriggerKey.CATEGORY_MATCH,
  TriggerKey.EMAIL_MATCH,
  TriggerKey.DOMAIN_MATCH,
];
